export default "/images/MailInCircle.png?39d8a959114ad89d82f218c17918e830";